module.exports = __webpack_public_path__ + "static/media/cnn.037a5f71.jpg";